import { ROLES } from 'src/constants';

// ----------------------------------------------------------------------

// Where a signed-in staff user lands. The first match wins: principals and
// finance go to the school dashboard, home ed staff to home ed, and a counsellor
// to the Careers dashboard, their home (#612). A counsellor who is also a
// principal keeps the school dashboard. Off-campus coordinators and everyone
// else land on the general dashboard.
export function landingPath(roles) {
  const has = (...wanted) => Array.isArray(roles) && wanted.some((r) => roles.includes(r));

  if (has(ROLES.USER_ROLE_SCHOOL_PRINCIPAL, ROLES.USER_ROLE_FINANCE_ADMIN)) return '/school-dashboard';
  if (has(ROLES.HOMESCHOOL_ADMIN, ROLES.HOMESCHOOL_FACILITATOR)) return '/home-ed';
  if (has(ROLES.USER_ROLE_COUNSELOR)) return '/careers-dashboard';
  return '/dashboard';
}
